export default __webpack_public_path__ + "9a697fe015255bb4cd6e4a5a00f36d83.svg";